import { z } from 'zod'

export const SpotInStampDataSchema = z.object({
  id: z.number(),
  name: z.string(),
  address: z.string().optional(),
  zip: z.string().optional(),
  image: z.string().nullable(),
})

export const StampInSheetDataSchema = z.object({
  id: z.number(),
  name: z.string(),
  image: z.string().nullable(),
  point: z.number(),
  spots: z.array(SpotInStampDataSchema).default([]),
})

export const SheetDataSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.enum(['stamp_rally', 'point_rally', 'point_card', 'overlay', 'none']),
  backgroundImage: z.string().nullable(),
  totalCount: z.number(),
  isLocked: z.boolean().optional().default(false),
  startAt: z.string().nullable().optional(),
  stamps: z.array(StampInSheetDataSchema),
})

export const SheetGetResponseSchema = z.object({
  sheet: SheetDataSchema.nullable(),
})

export const SheetListResponseSchema = z.object({
  sheets: z.array(SheetDataSchema),
})

export type SpotInStampData = z.infer<typeof SpotInStampDataSchema>
export type StampInSheetData = z.infer<typeof StampInSheetDataSchema>
export type SheetData = z.infer<typeof SheetDataSchema>
export type SheetGetResponse = z.infer<typeof SheetGetResponseSchema>
export type SheetListResponse = z.infer<typeof SheetListResponseSchema>

/** history 1件（スタンプ獲得履歴） */
export const UserSheetHistoryDataSchema = z.object({
  id: z.number(),
  stampId: z.number(),
  name: z.string(),
  image: z.string().nullable(),
  overlayImage: z.string().nullable(),
  acquiredCount: z.number(),
  /** 獲得時点の実際のポイント値。バックエンドが対応していない旧データは null になる */
  point: z.number().nullish(),
  createdAt: z.string().nullable(),
})

/** シート種別ごとの集計データ */
export const UserSheetMetaDataSchema = z.object({
  type: z.string().optional(),
  totalStampCount: z.number().nullish(),
  acquiredStampCount: z.number().nullish(),
  totalPoint: z.number().nullish(),
})

/** ユーザー向けシートデータ（SheetData に meta / history を追加）
 *
 * GET /api/v2/user/sheets は stamps を含まないため optional.default([]) で上書き。
 * useHomeStateMachine で GET /api/v2/sheets の stamps とマージして補完する。
 */
export const UserSheetDataSchema = SheetDataSchema.extend({
  stamps: z.array(StampInSheetDataSchema).optional().default([]),
  meta: UserSheetMetaDataSchema.nullable().optional(),
  history: z.array(UserSheetHistoryDataSchema).optional().default([]),
})

export const UserSheetListResponseSchema = z.object({
  sheets: z.array(UserSheetDataSchema),
})

export type UserSheetHistoryData = z.infer<typeof UserSheetHistoryDataSchema>
export type UserSheetMetaData = z.infer<typeof UserSheetMetaDataSchema>
export type UserSheetData = z.infer<typeof UserSheetDataSchema>
export type UserSheetListResponse = z.infer<typeof UserSheetListResponseSchema>
